import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import ModalBase from "modals/base/ModalBase";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./OptionRegisterModal.module.css";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import P from "components/P";
import { adminRequester } from "App";
import InputText from "components/inputs/InputText";
import { InputNumber } from "antd";
import { Tooltip } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
const OptionRegisterModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [true, false];
  const [isMounted, setMounted] = useState(false);
  const [reload, setReload] = useState(false);
  // const [categories, setCategories] = useState([]);
  const [options, setOptions] = useState(props.options || []);
  const [optionValues, setOptionValues] = useState(props.optionValues || []);
  const [width, height] = ["min(95%, 1200px)", "80vh"];
  const withCloseButton = true;
  const modal = useRef();
  const clickOutsideToClose = true;
  const title = "옵션 등록";
  const buttonText = t("close");
  const { isMobile } = useContext(BrowserDetectContext);
  const [selected, setSelected] = useState([]);
  const inputs = useRef([]);
  const input = useRef();

  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      input.current.focus();
    }
  }, [isMounted]);
  useEffect(() => {
    if (reload) {
      setReload(false);
    }
  }, [reload]);
  const addOptionValue = () => {
    const value = input.current.value;
    if (value) {
      setOptionValues([...new Set([...optionValues, value])]);
      input.current.value = null;
      setSelected([]);
    }
  };
  const addLine = () => {
    setOptions([
      ...options,
      { title: null, price: 0, quantity: 0, check: 0, sold: false },
    ]);
    setSelected([]);
  };
  const deleteLines = () => {
    if (selected.length === 0) {
      toast.error(t("항목을 선택해 주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    setOptions([
      ...options.filter((option, index) => !selected.includes(index)),
    ]);
    toast.success(t("삭제 성공"), {
      autoClose: 1000,
      position: toast.POSITION.BOTTOM_CENTER,
    });
    setSelected([]);
  };
  const duplicateLine = () => {
    if (selected.length === 0) {
      toast.error(t("항목을 선택해 주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    toast.success(t("복제 성공"), {
      autoClose: 1000,
      position: toast.POSITION.BOTTOM_CENTER,
    });
    const copies = options
      .filter((option, index) => selected.includes(index))
      .map((option) => {
        const copy = {
          ...option,
        };
        delete copy.id;
        return copy;
      });
    setOptions([...options, ...copies]);
    setSelected([]);
  };
  const onSaveClick = () => {
    if (optionValues.length === 0) {
      toast.error(t("최소 1가지의 새옵션이 필요합니다."), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      props.onChange(options, optionValues);
      modal.current.close();
    }
  };

  const Option = ({ name, index }) => {
    const [hover, setHover] = useState();
    return (
      <div
        style={{ cursor: "pointer", position: "relative" }}
        onClick={() => {
          const value = optionValues[index];
          optionValues.splice(index, 1);
          setOptionValues([...optionValues]);
        }}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {name}
        {hover && (
          <div
            style={{
              position: "absolute",
              zIndex: 100,
              bottom: 30,
              color: "red",
              minWidth: 220,
            }}
          >
            클릭시 해당 행을 제거합니다.
          </div>
        )}
      </div>
    );
  };
  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <div className={style.wrap}>
        <div className={style.detailContainer}>
          <VerticalFlex gap={30}>
            <HorizontalFlex gap={30}>
              <FlexChild gap={30}>
                <P>옵선 설정</P>
                <input
                  ref={input}
                  type="text"
                  style={{ border: "1px solid black", width: "90%" }}
                  placeholder="추가할 옵션명을 입력해주세요"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      addOptionValue();
                    }
                  }}
                />
              </FlexChild>
              <button onClick={addOptionValue}>새옵션</button>
            </HorizontalFlex>
            <VerticalFlex>
              <HorizontalFlex gap={30}>
                <FlexChild width={"50px"}>
                  <input
                    type="checkbox"
                    style={{ display: "block", margin: 5 }}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelected(options.map((option, index) => index));
                      } else {
                        setSelected([]);
                      }
                    }}
                    checked={selected.length === options.length}
                  />
                </FlexChild>
                {/* <P>옵선명</P>
                <P>옵션값</P> */}
                <FlexChild>
                  <div>이름</div>
                </FlexChild>
                {optionValues?.map((ov, index) => (
                  <FlexChild key={ov}>
                    {/* <div>{ov}</div> */}
                    <Option name={ov} index={index}></Option>
                  </FlexChild>
                ))}

                <FlexChild>
                  <div>{`증감액${
                    props.region ? ` (${t(props.region.currency_code)})` : ""
                  }`}</div>
                </FlexChild>
                <FlexChild>
                  <div>재고수량</div>
                </FlexChild>
                <FlexChild>
                  <div>안전재고</div>
                </FlexChild>
                <FlexChild width={"50px"}>
                  <div>품절</div>
                </FlexChild>
              </HorizontalFlex>
              {options?.map((option, index) => (
                <HorizontalFlex key={index} gap={30}>
                  <FlexChild width={"50px"}>
                    <input
                      type="checkbox"
                      style={{ display: "block", margin: 5 }}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelected([...selected, index]);
                        } else {
                          setSelected([
                            ...selected.filter((option) => option !== index),
                          ]);
                        }
                      }}
                      checked={selected.includes(index)}
                    />
                  </FlexChild>
                  <FlexChild>
                    <InputText
                      // ref={(el) => (inputs.current[inputs.current.length] = el)}
                      style={{ border: "1px solid gray", padding: 1 }}
                      name={"옵션명"}
                      controls={false}
                      onChange={(value) => (option.title = value)}
                      value={option.title}
                    />
                  </FlexChild>
                  {optionValues?.map((ov, index) => (
                    <FlexChild key={ov}>
                      <InputText
                        key={ov}
                        // ref={(el) => (inputs.current[index] = el)}
                        style={{ border: "1px solid gray", padding: 1 }}
                        name={ov}
                        onChange={(value) => (option[ov] = value)}
                        value={option[ov]}
                      />
                    </FlexChild>
                  ))}

                  <FlexChild>
                    <InputText
                      // ref={(el) => (inputs.current[inputs.current.length] = el)}
                      style={{ border: "1px solid gray", padding: 1 }}
                      name="증감액"
                      controls={false}
                      numberOnly
                      onChange={(value) => (option.price = value)}
                      value={String(option.price || 0)}
                    />
                  </FlexChild>
                  <FlexChild>
                    <InputText
                      // ref={(el) => (inputs.current[inputs.current.length] = el)}
                      style={{ border: "1px solid gray", padding: 1 }}
                      name={"재고수량"}
                      controls={false}
                      numberOnly
                      onChange={(value) => (option.quantity = value)}
                      value={String(option.quantity || 0)}
                    />
                  </FlexChild>
                  <FlexChild>
                    <InputText
                      // ref={(el) => (inputs.current[inputs.current.length] = el)}
                      style={{ border: "1px solid gray", padding: 1 }}
                      name={"안전재고"}
                      controls={false}
                      numberOnly
                      onChange={(value) => (option.check = value)}
                      value={option.check}
                    />
                  </FlexChild>
                  <FlexChild width={"50px"}>
                    <input
                      type="checkbox"
                      style={{ display: "block", margin: 5 }}
                      ref={(el) => (inputs.current[inputs.current.length] = el)}
                      onChange={(e) => {
                        option.sold = e.target.checked;
                        options[index] = option;
                        setOptions([...options]);
                      }}
                      checked={option.sold}
                    />
                  </FlexChild>
                  {/* <P>{option?.name}</P>
                  <P>{option?.}</P> */}
                </HorizontalFlex>
              ))}
            </VerticalFlex>
            <HorizontalFlex justifyContent="center">
              <FlexChild></FlexChild>
              <button onClick={addLine}>+</button>
              <HorizontalFlex justifyContent="end" gap={15}>
                <button onClick={deleteLines}>항목 삭제</button>
                <button onClick={duplicateLine}>항목 복사</button>
              </HorizontalFlex>
            </HorizontalFlex>

            <FlexChild>
              <button onClick={onSaveClick}>등록</button>
            </FlexChild>
          </VerticalFlex>
        </div>
      </div>
    </ModalBase>
  );
});

export default OptionRegisterModal;
